<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M28 27h-3V8a2 2 0 00-2-2V4.5a2 2 0 00-2-2H11a2 2 0 00-2 2V6a2 2 0 00-2 2v19H4a1 1 0 000 2h24a1 1 0 000-2zM11 4.5h10V6H11zM18.5 27h-5v-5.5h5zm4.5 0h-3.5v-5.5a1 1 0 00-1-1h-5a1 1 0 00-1 1V27H9V8h14z"/><path d="M14.25 10.5h-2.5a.5.5 0 000 1h2.5a.5.5 0 000-1zM14.25 13.5h-2.5a.5.5 0 000 1h2.5a.5.5 0 000-1zM14.25 16.5h-2.5a.5.5 0 000 1h2.5a.5.5 0 000-1zM20.25 10.5h-2.5a.5.5 0 000 1h2.5a.5.5 0 000-1zM20.25 13.5h-2.5a.5.5 0 000 1h2.5a.5.5 0 000-1zM20.25 16.5h-2.5a.5.5 0 000 1h2.5a.5.5 0 000-1z"/></svg>